export default __webpack_public_path__ + "assets/hospital-component.6058532e.svg";